import React, { useState, useEffect, useCallback, useMemo } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';

const Users = () => {
    const [ users, setUsers ] = useState([]);

    // https://stackoverflow.com/questions/72236570/display-axios-data-through-map-in-react-table


    const GetUsers = useCallback(() => { 
        axios.get('http://localhost:5000/Users/AllUsers')
            .then((response) => { 
                setUsers(response.data);
            })
            .catch((error) => { 
                console.log(error);
            });
    });

    useEffect(() => { 
        GetUsers();
    });
   
    return (
        <React.Fragment>
            <main>
                <h1>Users</h1>
                <span>
                    <Link to="/Admin/Users/Create" className="btn btn-secondary">Create</Link>
                </span>
                <section>

            <table className="table table-sm table-bordered table-bordered">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>First Name</th>
                        <th>Email</th>
                        <th>Update</th>
                        <th>Details</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        [...Array((users.length))].map((e, i) =>
                            <tr key={i}>
                                <td>{users[i]._id}</td>
                                <td>{users[i].firstName}</td>
                                <td>{users[i].email}</td>
                                <td><Link to={"/Admin/Users/Update/" + users[i]._id}>Update</Link></td>
                                <td><Link to={"/Admin/Users/Details/" + users[i]._id}>Details</Link></td>
                                <td><Link to={"/Admin/Users/Delete/" + users[i]._id}>Delete</Link></td>
                            </tr>
                        )
                    }
                </tbody>
            </table>
            </section>
            </main>
        </React.Fragment>
    )
}





export default Users;